"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lightPalette = exports.darkPalette = exports.getCybertronTheme = exports.monospaceInputStyles = exports.inlineInputStyles = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
require("@sbu/fonts.labgrotesque");
const material_1 = require("@mui/material");
const check_svg_1 = __importDefault(require("@sbu/assets.svg/src/check.svg"));
const close_svg_1 = __importDefault(require("@sbu/assets.svg/src/close.svg"));
const double_chevron_down_svg_1 = __importDefault(require("@sbu/assets.svg/src/double-chevron-down.svg"));
// TODO: merge remove.svg and remove2.svg as part of APP-2688.
const remove2_svg_1 = __importDefault(require("@sbu/assets.svg/src/remove2.svg"));
const darkPalette_1 = require("./darkPalette");
const lightPalette_1 = require("./lightPalette");
const shapes_1 = require("./shapes");
const typography_1 = require("./typography");
const YamaColors_1 = __importDefault(require("./YamaColors"));
const SPACING_FACTOR = 8;
exports.inlineInputStyles = {
    color: 'link.main',
    fontSize: 'inherit',
    '.MuiInput-input.MuiSelect-select, .MuiInput-input.MuiAutocomplete-input, .MuiInputBase-input.MuiInput-input': {
        paddingTop: 0,
        paddingBottom: 0.25,
    },
};
exports.monospaceInputStyles = {
    fontFamily: `Roboto Mono, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace`,
};
// TODO: Adjust h5 and h6 styling when appropriate. For now, do not use
const getCybertronTheme = (mode) => {
    const { background, border, chart, common, divider, error, grey, icon, info, link, primary, secondary, status, success, text, warning, reputation, toast, } = mode === 'dark' ? darkPalette_1.darkPalette : lightPalette_1.lightPalette;
    const { h1, h2, h3, h4, h5, h6, subtitle1, subtitle2, body1, body2, button, caption, } = (0, typography_1.getTypography)(text);
    // Default Prop Components =====================================================
    const CloseIcon = (props) => ((0, jsx_runtime_1.jsx)(close_svg_1.default, Object.assign({ "aria-hidden": true, height: 10, role: 'img', width: 10, color: icon }, props)));
    const SelectIcon = () => ((0, jsx_runtime_1.jsx)(material_1.SvgIcon, { "aria-hidden": true, component: double_chevron_down_svg_1.default, sx: {
            height: 12,
            stroke: 'none',
            width: 12,
            fill: icon,
            '&:hover': {
                fill: primary.light,
            },
        } }));
    // Exportable Objects ==========================================================
    const tooltipStyles = Object.assign(Object.assign({}, caption), { backgroundColor: background.paper, display: 'flex', maxWidth: '200px', padding: '10px 12px', position: 'relative', '&:before': {
            bgcolor: 'transparent',
            borderLeft: '1px solid',
            borderColor: info.main,
            content: '""',
            left: 0,
            height: '100%',
            position: 'absolute',
            top: 0,
            width: 1,
        }, '&:after': {
            borderRight: '1px solid',
            borderColor: info.main,
            content: '""',
            right: 0,
            height: '100%',
            position: 'absolute',
            top: 0,
            width: 1,
        } });
    // Shape =======================================================================
    const shape = {
        borderRadius: 0,
        polygon: shapes_1.createPolygon,
    };
    // Overrides ===================================================================
    const menuItemSelectedAndHoverStyles = {
        backgroundColor: `${background.paperHover} !important`,
    };
    const menuItemStyles = Object.assign(Object.assign({}, body1), { backgroundColor: background.default, paddingTop: SPACING_FACTOR, paddingBottom: SPACING_FACTOR, paddingLeft: 2 * SPACING_FACTOR, paddingRight: 2 * SPACING_FACTOR, '&:hover, &:focus, &.Mui-focused, &.Mui-selected': Object.assign({}, menuItemSelectedAndHoverStyles), '& + .MuiDivider-root': {
            marginTop: 1.25 * SPACING_FACTOR,
            marginBottom: 1.25 * SPACING_FACTOR,
        } });
    const popperAndPopoverPaperStyles = {
        backgroundImage: 'none',
        // Needed for some extra specificity
        '&.MuiPaper-root': {
            backgroundImage: 'none',
            border: '1px solid',
            borderColor: border,
            marginTop: SPACING_FACTOR,
            '.MuiAutocomplete-listbox': {
                padding: 0,
                '& .MuiAutocomplete-option[aria-selected="true"]': Object.assign({}, menuItemSelectedAndHoverStyles),
            },
        },
    };
    const MuiAccordion = {
        defaultProps: {
            disableGutters: true,
            elevation: 0,
            square: true,
        },
        styleOverrides: {
            root: Object.assign({ width: '100%', '&.Mui-disabled': {
                    backgroundColor: 'transparent',
                }, '&.Mui-expanded': {
                    margin: 0,
                } }, (0, shapes_1.drawBorder)({ color: grey[700] })),
        },
    };
    const MuiAccordionDetails = {
        styleOverrides: {
            root: {
                paddingBottom: 16,
                paddingLeft: 0,
                paddingRight: 0,
                paddingTop: 8,
            },
        },
    };
    const MuiAccordionSummary = {
        styleOverrides: {
            content: {
                fontSize: 16,
                fontWeight: 700,
            },
            root: {
                minHeight: 48,
                padding: 0,
                paddingRight: 4,
                '&.Mui-expanded': {
                    minHeight: 48,
                },
            },
        },
    };
    const MuiAutocomplete = {
        defaultProps: {
            clearIcon: (0, jsx_runtime_1.jsx)(CloseIcon, {}),
            popupIcon: (0, jsx_runtime_1.jsx)(SelectIcon, {}),
        },
        styleOverrides: {
            inputRoot: {
                paddingBottom: 0,
                '.MuiInput-input': {
                    paddingTop: SPACING_FACTOR,
                    paddingBottom: SPACING_FACTOR,
                },
            },
            clearIndicator: {
                paddingTop: 0.25 * SPACING_FACTOR,
                paddingBottom: 0.25 * SPACING_FACTOR,
                paddingLeft: 0.5 * SPACING_FACTOR,
                paddingRight: 0.5 * SPACING_FACTOR,
            },
            groupUl: {
                '& .MuiAutocomplete-option': {
                    paddingLeft: SPACING_FACTOR * 2,
                },
            },
            listbox: {
                '& .MuiAutocomplete-option': {
                    paddingBottom: SPACING_FACTOR,
                    paddingLeft: 2 * SPACING_FACTOR,
                    paddingRight: 2 * SPACING_FACTOR,
                    paddingTop: SPACING_FACTOR,
                },
            },
            option: menuItemStyles,
            paper: Object.assign({}, popperAndPopoverPaperStyles),
            popupIndicator: {
                marginRight: 4,
                transform: 'rotate(0deg)',
                transition: 'all 0.3s ease-in-out',
                '& svg': {
                    marginRight: '0 !important',
                },
            },
            popupIndicatorOpen: {
                transform: 'rotate(-180deg)',
            },
            endAdornment: {
                top: 'revert',
            },
        },
    };
    const MuiBadge = {
        defaultProps: {
            variant: 'dot',
        },
        styleOverrides: {
            dot: {
                height: 0.75 * SPACING_FACTOR,
                minWidth: 0.75 * SPACING_FACTOR,
            },
        },
    };
    const MuiButton = {
        defaultProps: {
            disableFocusRipple: true,
            disableRipple: true,
            disableTouchRipple: true,
            disableElevation: true,
        },
        styleOverrides: {
            root: {
                textTransform: 'none',
                fontSize: '1rem',
                lineHeight: 'normal',
            },
        },
        variants: [
            // Size Styling
            {
                props: { size: 'medium' },
                style: {
                    '.MuiButton-startIcon, .MuiButton-endIcon': {
                        svg: {
                            height: 16,
                            width: 16,
                        },
                    },
                },
            },
            {
                props: { size: 'medium', variant: 'contained' },
                style: {
                    minWidth: 100,
                    height: 36,
                    padding: `0px ${SPACING_FACTOR * 1.5}px`,
                },
            },
            {
                props: { size: 'medium', variant: 'text' },
                style: {
                    minWidth: 100,
                    height: 36,
                    padding: `0px ${SPACING_FACTOR * 1.5}px`,
                },
            },
            {
                props: { size: 'small' },
                style: {
                    '.MuiButton-startIcon, .MuiButton-endIcon': {
                        svg: {
                            height: 14,
                            width: 14,
                        },
                    },
                },
            },
            {
                props: { size: 'small', variant: 'contained' },
                style: {
                    height: 28,
                    padding: `0px ${SPACING_FACTOR * 1.5}px`,
                },
            },
            {
                props: { size: 'small', variant: 'text' },
                style: {
                    height: 28,
                    padding: `0px ${SPACING_FACTOR * 1.5}px`,
                },
            },
            {
                props: { variant: 'outlined' },
                style: {
                    padding: `${SPACING_FACTOR * 0.75}px ${SPACING_FACTOR * 1.5}px`,
                },
            },
            // Contained Variant Styling
            {
                props: { variant: 'contained' },
                style: {
                    fontWeight: 400,
                    '&:disabled, &.Mui-disabled': {
                        opacity: 0.5,
                    },
                },
            },
            {
                props: { variant: 'contained', color: 'primary' },
                style: {
                    backgroundColor: primary.main,
                    '&:hover': {
                        backgroundColor: primary.light,
                    },
                    '&:focus': {
                        backgroundColor: primary.dark,
                    },
                    '&, &:visited, &:focus, &:hover': {
                        color: primary.contrastText,
                    },
                    'svg, path': {
                        color: primary.contrastText,
                        fill: primary.contrastText,
                    },
                    '&:disabled, &.Mui-disabled': {
                        color: primary.contrastText,
                        backgroundColor: primary.main,
                    },
                },
            },
            {
                props: { variant: 'contained', color: 'secondary' },
                style: {
                    backgroundColor: secondary.main,
                    '&:hover': {
                        backgroundColor: secondary.light,
                    },
                    '&:focus': {
                        backgroundColor: secondary.dark,
                    },
                    '&, &:visited, &:focus, &:hover': {
                        color: secondary.contrastText,
                    },
                    'svg, path': {
                        color: secondary.contrastText,
                        fill: secondary.contrastText,
                    },
                    '&:disabled, &.Mui-disabled': {
                        color: secondary.contrastText,
                        backgroundColor: secondary.main,
                    },
                },
            },
            {
                props: { variant: 'contained', color: 'error' },
                style: {
                    backgroundColor: error.main,
                    '&:hover': {
                        backgroundColor: error.light,
                    },
                    '&:focus': {
                        backgroundColor: error.dark,
                    },
                    '&, &:visited, &:focus, &:hover': {
                        color: error.contrastText,
                    },
                    'svg, path': {
                        color: error.contrastText,
                        fill: error.contrastText,
                    },
                    '&:disabled, &.Mui-disabled': {
                        color: error.contrastText,
                        backgroundColor: error.main,
                    },
                },
            },
            // Text Variant Styling
            {
                props: { variant: 'text' },
                style: {
                    '&, .MuiTypography-root': {
                        fontWeight: 500,
                    },
                    '&, &:hover, &:focus': {
                        backgroundColor: 'transparent',
                    },
                    '&:disabled, &.Mui-disabled': {
                        opacity: 0.5,
                    },
                },
            },
            {
                props: { variant: 'text', color: 'primary' },
                style: {
                    '&, &:visited': {
                        color: text.primary,
                        'svg, path': {
                            color: text.primary,
                            fill: text.primary,
                        },
                    },
                    '&:hover': {
                        color: primary.light,
                        'svg, path': {
                            color: primary.light,
                            fill: primary.light,
                        },
                    },
                    '&:focus': {
                        color: YamaColors_1.default['primary-20'],
                        'svg, path': {
                            color: YamaColors_1.default['primary-20'],
                            fill: YamaColors_1.default['primary-20'],
                        },
                    },
                    '&:disabled, &.Mui-disabled': {
                        color: text.primary,
                        'svg, path': {
                            color: text.primary,
                            fill: text.primary,
                        },
                    },
                },
            },
            {
                props: { variant: 'text', color: 'secondary' },
                style: {
                    '&, &:visited': {
                        color: text.secondary,
                        'svg, path': {
                            color: text.secondary,
                            fill: text.secondary,
                        },
                    },
                    '&:hover': {
                        color: YamaColors_1.default['grey-30'],
                        'svg, path': {
                            color: YamaColors_1.default['grey-30'],
                            fill: YamaColors_1.default['grey-30'],
                        },
                    },
                    '&:focus': {
                        color: YamaColors_1.default['grey-70'],
                        'svg, path': {
                            color: YamaColors_1.default['grey-70'],
                            fill: YamaColors_1.default['grey-70'],
                        },
                    },
                    '&:disabled, &.Mui-disabled': {
                        color: text.secondary,
                        'svg, path': {
                            color: text.secondary,
                            fill: text.secondary,
                        },
                    },
                },
            },
            // Outlined Variant Styling
            {
                props: { variant: 'outlined' },
                style: {
                    color: icon,
                    fontWeight: 500,
                    'svg, path': {
                        color: icon,
                        fill: icon,
                    },
                    '&, &:hover, &:focus, &:visited': {
                        color: text.primary,
                        backgroundColor: background.paper,
                        borderColor: grey[700],
                    },
                    '&:disabled, &.Mui-disabled': {
                        opacity: 0.5,
                        backgroundColor: background.paper,
                        color: text.primary,
                        'svg, path': {
                            color: icon,
                            fill: icon,
                        },
                    },
                },
            },
        ],
    };
    const MuiCard = {
        styleOverrides: {
            root: {
                backgroundImage: 'none',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                bgcolor: background.paper,
                border: '1px solid',
                borderColor: border,
            },
        },
    };
    const MuiCardActions = {
        styleOverrides: {
            root: {
                backgroundColor: background.default,
                borderTop: '1px solid',
                borderColor: border,
                flexDirection: 'column',
            },
        },
    };
    const MuiCardContent = {
        styleOverrides: {
            root: {
                padding: '16px 40px 0',
            },
        },
    };
    const MuiCheckbox = {
        defaultProps: {
            checkedIcon: ((0, jsx_runtime_1.jsx)(material_1.Zoom, { in: true, children: (0, jsx_runtime_1.jsx)(material_1.SvgIcon, { sx: {
                        '& path': {
                            fill: YamaColors_1.default['white-30'],
                        },
                    }, children: (0, jsx_runtime_1.jsx)(check_svg_1.default, {}) }) })),
            disableFocusRipple: true,
            disableRipple: true,
            disableTouchRipple: true,
            indeterminateIcon: ((0, jsx_runtime_1.jsx)(material_1.Zoom, { in: true, children: (0, jsx_runtime_1.jsx)(material_1.SvgIcon, { inheritViewBox: true, sx: {
                        px: 0.25,
                        '& path': {
                            fill: info.contrastText,
                        },
                    }, children: (0, jsx_runtime_1.jsx)(remove2_svg_1.default, { height: '100%', width: '100%' }) }) })),
        },
        styleOverrides: {
            root: {
                bgcolor: 'transparent',
                border: '1px solid',
                borderColor: grey[500],
                borderRadius: 0,
                boxSizing: 'border-box',
                padding: 0,
                '& svg': {
                    backgroundColor: info.main,
                    fill: info.contrastText,
                },
                '&.MuiCheckbox-sizeSmall': {
                    height: 16,
                    width: 16,
                    '& svg': {
                        height: 12,
                        width: 12,
                    },
                },
                '&.MuiCheckbox-sizeMedium': {
                    height: 26,
                    width: 26,
                    '& svg': {
                        height: 18,
                        width: 18,
                    },
                },
                ':hover, &.Mui-checked, &.MuiCheckbox-indeterminate': {
                    borderColor: info.light,
                },
                ':not(.Mui-checked):not(.MuiCheckbox-indeterminate) .MuiSvgIcon-root': {
                    visibility: 'hidden',
                },
                'input:disabled ~ &': {
                    boxShadow: 'none',
                    background: grey[400],
                },
                '&.Mui-disabled': {
                    borderColor: grey[400],
                    '&.Mui-checked svg': {
                        backgroundColor: grey[400],
                    },
                },
            },
        },
    };
    const MuiChip = {
        defaultProps: {
            variant: 'filled',
        },
        styleOverrides: {
            label: {
                width: '100%',
            },
            outlined: {
                border: '1px solid',
                borderColor: info.dark,
            },
            root: {
                backgroundColor: background.chip,
                borderRadius: 0,
                boxSizing: 'border-box',
                '&.Mui-disabled': {
                    opacity: 0.5,
                },
            },
            sizeMedium: Object.assign(Object.assign({}, body1), { height: 'auto', minHeight: 24, '& .MuiChip-label': {
                    display: 'block',
                    justifyContent: 'space-between',
                    paddingTop: 0.375 * SPACING_FACTOR,
                    paddingBottom: 0.375 * SPACING_FACTOR,
                    paddingLeft: SPACING_FACTOR,
                    paddingRight: SPACING_FACTOR,
                    whiteSpace: 'normal',
                } }),
            sizeSmall: Object.assign(Object.assign({}, body2), { height: 18, minWidth: 18, '& .MuiChip-label': {
                    color: text.secondary,
                    justifyContent: 'center',
                    paddingLeft: 0.25 * SPACING_FACTOR,
                    paddingRight: 0.25 * SPACING_FACTOR,
                } }),
        },
    };
    const MuiCssBaseline = {
        styleOverrides: {
            html: {
                fontSize: 14,
            },
            body: {
                fontSize: 14,
                lineHeight: 1.1,
            },
            a: {
                fontSize: '0.875rem',
                transition: 'color 0.3s',
                textDecoration: 'none',
                backgroundColor: 'transparent',
                ':hover': {
                    color: link.hover,
                    textDecoration: 'none',
                },
            },
        },
    };
    const MuiFormControlLabel = {
        styleOverrides: {
            root: {
                margin: 0,
            },
        },
    };
    const MuiFormHelperText = {
        styleOverrides: {
            root: Object.assign(Object.assign({}, body1), { '&.Mui-error': {
                    color: text.error,
                } }),
        },
    };
    const MuiFormLabel = {
        styleOverrides: {
            root: {
                '&.MuiInputLabel-shrink': {
                    lineHeight: '1',
                    transform: 'translate(0, -1.5px)',
                },
                '&.Mui-focused, &.Mui-focused .MuiFormLabel-asterisk, &.Mui-error, &:not(.Mui-focused) .MuiFormLabel-asterisk.Mui-error': {
                    color: text.secondary,
                },
                '&.Mui-disabled': {
                    color: grey[400],
                },
            },
        },
    };
    const MuiDialog = {
        styleOverrides: {
            root: {
                '& .MuiPaper-root': {
                    backgroundImage: 'none',
                    border: '1px solid',
                    borderColor: border,
                    maxHeight: '80vh',
                    padding: 4 * SPACING_FACTOR,
                },
                paper: {
                    backgroundImage: 'none',
                },
            },
        },
    };
    const MuiDialogActions = {
        defaultProps: {},
        styleOverrides: {
            root: {
                padding: 0,
            },
            spacing: {
                '> :not(:first-of-type)': {
                    marginLeft: 3 * SPACING_FACTOR,
                },
            },
        },
    };
    const MuiDialogContent = {
        defaultProps: {},
        styleOverrides: {
            root: Object.assign(Object.assign({}, body1), { marginBottom: 2 * SPACING_FACTOR, padding: 0 }),
        },
    };
    const MuiDialogTitle = {
        defaultProps: {},
        styleOverrides: {
            root: {
                fontSize: '1.5rem',
                fontWeight: 700,
                marginBottom: 2 * SPACING_FACTOR,
                padding: 0,
            },
        },
    };
    const MuiDivider = {
        styleOverrides: {
            root: {
                position: 'relative',
                overflow: 'visible',
                borderColor: divider,
            },
        },
    };
    const MuiDrawer = {
        styleOverrides: {
            paper: {
                backgroundColor: 'background.default',
                backgroundImage: 'none',
                padding: 4 * SPACING_FACTOR,
            },
        },
    };
    const MuiIconButton = {
        defaultProps: {
            disableFocusRipple: true,
            disableRipple: true,
            disableTouchRipple: true,
        },
        styleOverrides: {
            root: {
                borderRadius: 0,
                fill: icon,
                stroke: icon,
                padding: 0,
                '&:link': {
                    color: icon,
                },
                '&:hover': {
                    color: primary.light,
                    fill: primary.light,
                    stroke: primary.light,
                },
                '&:focus': {
                    color: mode === 'dark' ? YamaColors_1.default['primary-20'] : primary.main,
                    fill: mode === 'dark' ? YamaColors_1.default['primary-20'] : primary.main,
                    stroke: mode === 'dark' ? YamaColors_1.default['primary-20'] : primary.main,
                },
                '&:disabled, &.Mui-disabled': {
                    color: icon,
                    opacity: 0.5,
                },
            },
        },
    };
    const MuiInput = {
        styleOverrides: {
            root: Object.assign(Object.assign({}, body1), { '&.Mui-disabled': {
                    color: grey[400],
                    '-webkit-text-fill-color': grey[400],
                    '&:before': {
                        borderBottomColor: grey[400],
                        borderBottomStyle: 'solid',
                    },
                }, '.MuiInput-input:focus': {
                    backgroundColor: 'transparent',
                } }),
            underline: {
                '&:not(.Mui-disabled)': {
                    '&:before': {
                        borderBottomColor: info.light,
                    },
                    '&:hover': {
                        '&:before': {
                            borderBottomColor: info.light,
                        },
                    },
                    '&.Mui-focused, &:focus, &:active': {
                        '&:before': {
                            borderBottomColor: text.primary,
                        },
                        '&:after': {
                            borderBottomColor: text.primary,
                        },
                        '&.Mui-error': {
                            '&:before': {
                                borderBottomColor: error.main,
                            },
                            '&:after': {
                                borderBottomColor: error.main,
                            },
                        },
                    },
                    '&.Mui-error': {
                        '&:before': {
                            borderBottomColor: error.main,
                        },
                        '&:after': {
                            borderBottomColor: error.main,
                        },
                    },
                },
                '&.Mui-disabled': {
                    '&:before': {
                        borderBottomColor: grey[400],
                    },
                },
            },
        },
    };
    const MuiInputLabel = {
        defaultProps: {
            shrink: true,
            variant: 'standard',
        },
        styleOverrides: {
            root: Object.assign(Object.assign({}, body1), { '&.Mui-focused': {
                    color: text.secondary,
                    bgcolor: 'none',
                } }),
        },
    };
    const MuiLink = {
        styleOverrides: {
            root: {
                color: link.main,
                '&:hover, &:focus': {
                    color: link.hover,
                },
                '&:visited': {
                    color: link.visited,
                },
                '&[aria-disabled=true]': {
                    color: link.disabled,
                    pointerEvents: 'none',
                },
            },
        },
    };
    const MuiList = {
        defaultProps: {
            disablePadding: true,
        },
    };
    const MuiListSubheader = {
        defaultProps: {
            disableSticky: true,
        },
        styleOverrides: {
            root: Object.assign(Object.assign({}, subtitle1), { backgroundColor: background.paper, lineHeight: 'normal', opacity: 1, paddingTop: SPACING_FACTOR, paddingRight: SPACING_FACTOR * 2, paddingBottom: SPACING_FACTOR, paddingLeft: SPACING_FACTOR * 2 }),
        },
    };
    const MuiMenu = {
        defaultProps: {
            PaperProps: {
                elevation: 0,
            },
        },
    };
    const MuiMenuItem = {
        defaultProps: {
            disableRipple: true,
            disableTouchRipple: true,
        },
        styleOverrides: {
            root: menuItemStyles,
        },
    };
    const MuiPopover = {
        styleOverrides: {
            paper: {
                backgroundImage: 'none',
                '&.MuiPaper-root': {
                    backgroundImage: 'none',
                    border: '1px solid',
                    borderColor: border,
                },
            },
        },
    };
    const MuiSelect = {
        defaultProps: {
            IconComponent: SelectIcon,
            MenuProps: {
                marginThreshold: 0,
                PaperProps: {
                    elevation: 0,
                },
                sx: {
                    mt: 1,
                },
            },
            variant: 'standard',
        },
        styleOverrides: {
            select: {
                '&.MuiInput-input': {
                    paddingRight: SPACING_FACTOR * 3.5,
                },
                paddingTop: SPACING_FACTOR,
                paddingBottom: SPACING_FACTOR,
            },
            icon: {
                top: 'revert',
                right: SPACING_FACTOR,
                fill: icon,
                '&.Mui-disabled': {
                    fill: `${grey[400]} !important`,
                },
            },
        },
    };
    const MuiSwitch = {
        defaultProps: {
            disableFocusRipple: true,
            disableRipple: true,
        },
        styleOverrides: {
            colorPrimary: {
                '&.Mui-checked': {
                    '& .MuiSwitch-thumb': {
                        '&:after': {
                            backgroundColor: success.main,
                        },
                    },
                },
                '& .MuiSwitch-thumb': {
                    '&:after': {
                        backgroundColor: error.main,
                    },
                },
            },
            colorSecondary: {
                '&.Mui-checked': {
                    '& .MuiSwitch-thumb': {
                        '&:after': {
                            backgroundColor: primary.light,
                        },
                    },
                },
                '& .MuiSwitch-thumb': {
                    '&:after': {
                        backgroundColor: primary.main,
                    },
                },
            },
            root: {
                height: 26,
                padding: '5px 0',
                width: 44,
                '& .MuiTouchRipple-root': {
                    top: -9,
                },
            },
            switchBase: {
                borderRadius: 0,
                padding: 0,
                '&.Mui-checked': {
                    transform: 'translateX(18px)',
                },
                '&+.MuiSwitch-track, &.Mui-checked+.MuiSwitch-track': {
                    backgroundColor: secondary.dark,
                    opacity: 1,
                },
                '&.Mui-disabled': {
                    backgroundColor: background.paper,
                },
                '&.Mui-disabled+.MuiSwitch-track': {
                    opacity: 0.5,
                },
                '&.Mui-disabled .MuiSwitch-thumb': {
                    opacity: 0.5,
                    '&:after': {
                        opacity: 0.5,
                    },
                },
            },
            thumb: {
                backgroundColor: secondary.dark,
                borderRadius: 0,
                boxShadow: 'none',
                height: 26,
                transition: 'all 0.3s ease-in-out',
                width: 26,
                '&:before': {
                    border: '1px solid',
                    borderColor: secondary.light,
                    content: '""',
                    height: 26,
                    position: 'absolute',
                    right: 0,
                    width: 26,
                },
                '&:after': {
                    content: '""',
                    height: 18,
                    left: 4,
                    position: 'absolute',
                    right: 0,
                    top: 4,
                    width: 18,
                },
            },
            track: {
                backgroundColor: 'transparent',
                border: '1px solid',
                borderColor: secondary.light,
                borderRadius: 0,
                boxSizing: 'content-box',
                height: 14,
            },
        },
    };
    const MuiTable = {
        defaultProps: {
            size: 'small',
        },
        styleOverrides: {
            root: {
                borderCollapse: 'collapse',
            },
        },
    };
    const MuiTableCell = {
        styleOverrides: {
            body: {
                backgroundColor: background.paper,
                color: text.primary,
            },
            head: {
                backgroundColor: background.default,
                color: text.primary,
                fontSize: 14,
            },
            root: {
                borderBottom: '1px solid',
                borderBottomColor: border,
                paddingLeft: 8,
                paddingRight: 8,
                '& a': {
                    color: link.main,
                    textDecoration: 'none',
                },
            },
            sizeSmall: {
                '.MuiTableCell-root': {
                    fontSize: 16,
                },
                '.MuiTableCell-head': {
                    fontSize: 14,
                    fontWeight: 500,
                    textTransform: 'uppercase',
                },
            },
        },
    };
    const MuiTableHead = {
        styleOverrides: {},
    };
    const MuiTableRow = {
        styleOverrides: {
            root: {
                border: '1px solid',
                borderColor: border,
            },
        },
    };
    const MuiTextField = {
        defaultProps: {
            variant: 'standard',
            SelectProps: {
                MenuProps: {
                    sx: { mt: 1 },
                },
            },
        },
        styleOverrides: {
            root: {
                '& ::placeholder': {
                    color: text.primary,
                },
                '.MuiInput-input': {
                    paddingTop: SPACING_FACTOR,
                    paddingBottom: SPACING_FACTOR,
                },
            },
        },
    };
    const MuiToggleButton = {
        defaultProps: {
            disableFocusRipple: true,
            disableRipple: true,
            size: 'medium',
        },
        styleOverrides: {
            sizeSmall: {
                paddingLeft: SPACING_FACTOR * 1.5,
                paddingRight: SPACING_FACTOR * 1.5,
                paddingTop: 0.75 * SPACING_FACTOR,
                paddingBottom: 0.75 * SPACING_FACTOR,
                fontSize: '1rem',
            },
            sizeMedium: {
                paddingLeft: SPACING_FACTOR * 3,
                paddingRight: SPACING_FACTOR * 3,
                paddingTop: 0.75 * SPACING_FACTOR,
                paddingBottom: 0.75 * SPACING_FACTOR,
                fontSize: '1rem',
                // Based on designs, the min width of the button is
                // minimum 112px content width +  1 * 1px borders + 2 * left and right padding
                minWidth: 114 + SPACING_FACTOR * 3 * 2,
            },
            root: {
                border: '1px solid',
                borderColor: YamaColors_1.default['black-60'],
                color: text.primary,
                textTransform: 'none',
                lineHeight: 'normal',
                svg: {
                    color: mode === 'dark' ? text.primary : text.secondary,
                    fill: mode === 'dark' ? text.primary : text.secondary,
                    '& path': {
                        fill: mode === 'dark' ? text.primary : text.secondary,
                    },
                },
                '&.Mui-selected, &.Mui-selected:hover, &:hover': {
                    color: YamaColors_1.default['white-30'],
                    backgroundColor: YamaColors_1.default['black-60'],
                    svg: {
                        color: YamaColors_1.default['white-30'],
                        fill: YamaColors_1.default['white-30'],
                        '& path': {
                            fill: YamaColors_1.default['white-30'],
                        },
                    },
                },
            },
        },
    };
    const MuiPopper = {
        // This type isn't provided with our current MUI version.
        // Remove when upgrading to MUI version 5.14.13 (when it was fixed) or newer.
        // @ts-ignore
        styleOverrides: {
            root: {
                '&.MuiPopper-root': {
                    // Use 1300 to match modal/other menus:
                    // https://mui.com/material-ui/customization/z-index/
                    zIndex: 1300,
                },
            },
        },
    };
    const MuiTooltip = {
        defaultProps: {
            PopperProps: {
                placement: 'auto',
            },
        },
        styleOverrides: {
            tooltip: tooltipStyles,
        },
    };
    const MuiTypography = {
        styleOverrides: {
            root: {
                padding: 0,
            },
        },
    };
    return (0, material_1.createTheme)({
        components: {
            MuiAccordion,
            MuiAccordionDetails,
            MuiAccordionSummary,
            MuiAutocomplete,
            MuiBadge,
            MuiButton,
            MuiCard,
            MuiCardActions,
            MuiCardContent,
            MuiCheckbox,
            MuiChip,
            MuiCssBaseline,
            MuiDialog,
            MuiDialogActions,
            MuiDialogContent,
            MuiDialogTitle,
            MuiDivider,
            MuiDrawer,
            MuiFormControlLabel,
            MuiFormHelperText,
            MuiFormLabel,
            MuiIconButton,
            MuiInput,
            MuiInputLabel,
            MuiLink,
            MuiList,
            MuiListSubheader,
            MuiMenu,
            MuiMenuItem,
            MuiPopper,
            MuiPopover,
            MuiSelect,
            MuiSwitch,
            MuiTable,
            MuiTableCell,
            MuiTableHead,
            MuiTableRow,
            MuiTextField,
            MuiToggleButton,
            MuiTooltip,
            MuiTypography,
        },
        typography: {
            fontFamily: '"Lab Grotesque", sans-serif, Arial',
            h1,
            h2,
            h3,
            h4,
            h5,
            h6,
            subtitle1,
            subtitle2,
            body1,
            body2,
            button,
            caption,
        },
        spacing: SPACING_FACTOR,
        palette: {
            background,
            border,
            chart,
            common,
            error,
            grey,
            icon,
            info,
            link,
            primary,
            secondary,
            status,
            success,
            text,
            mode,
            warning,
            reputation,
            toast,
        },
        shape,
    });
};
exports.getCybertronTheme = getCybertronTheme;
var darkPalette_2 = require("./darkPalette");
Object.defineProperty(exports, "darkPalette", { enumerable: true, get: function () { return darkPalette_2.darkPalette; } });
var lightPalette_2 = require("./lightPalette");
Object.defineProperty(exports, "lightPalette", { enumerable: true, get: function () { return lightPalette_2.lightPalette; } });
exports.default = exports.getCybertronTheme;
